<script>
import IconExclamationCircle from '@/components/icons/ExclamationCircle';

export default ({ $style, children }) => (
  <div class={$style.wrapper}>
    <IconExclamationCircle class={$style.icon} />

    <div class={$style.text}>
      {children}
    </div>
  </div>
);
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  align-items: center;
  display: flex;
  margin: 1em 0;

  & + & {
    margin-top: 0;
  }
}

.icon {
  color: $color-red-darkest;
  flex-grow: 0;
  flex-shrink: 1;
  margin-right: .5em;
}

.text {
  flex-grow: 1;
  flex-shrink: 1;
  font-size: .825em;
}
</style>
